import React, { FC, Fragment, memo, useEffect, useState } from 'react'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import Link from 'next/link'
import { Chips } from '@ucheba/ui/components/Chips/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Param } from '@ucheba/ui/components/Param/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import CheckIcon from '@ucheba/ui/icons/icon__check_circle-outline.svg'
import { useSelector } from 'react-redux'
import { plannerSpecialtiesSelectors } from '@ucheba/store/planner/specialties'
import { ELoading } from '@ucheba/store/utils/response/types'
import styled from 'styled-components'
import { ISpecialitiesListItemProps } from '../types'
import SC from '../base/SpecialitiesListItem.styles'
import { useSpecialitiesListItemCore } from '../bll'
import { SpecialitiesListIconMore } from '../base/SpecialitiesListIconMore'

const { Block } = SC

const GridSC = styled(Grid)`
  margin: 0;
`

/** Специальность */
const SpecialitiesListItem: FC<ISpecialitiesListItemProps> = (props) => {
  const {
    id,
    name,
    shortDescription,
    showSelect,
    selectedItems,
    onSelect,
    offSelect,
    exams,
    linkTarget,
  } = props

  const {
    institutions,
    budget,
    score,
    examsSts,
    level,
    showAllEge,
    shownAllEge,
    href,
    institutionsHref,
    icons,
  } = useSpecialitiesListItemCore(props)

  // костыль - нужно править
  const loading = useSelector(plannerSpecialtiesSelectors.loading)
  const isLoading = loading === ELoading.pending
  const [panding, setPanding] = useState(false)

  useEffect(() => {
    if (loading !== ELoading.pending) {
      setPanding(false)
    }
  }, [panding, loading])

  return (
    <Block>
      <Grid nowrap justifyContent='space-between'>
        <GridCol width='auto' shrink='initial'>
          <Text fontSize='h3' fontWeight='bold' lineHeight='h3' color='blue' html={false}>
            <a
              href={href}
              color='inherit'
              target={linkTarget || '_self'}
              rel='noreferrer'
            >
              {name}
            </a>
          </Text>
        </GridCol>

        <GridCol width='auto'>
          <Chips color='gray5' firstLetterUppercase>
            {level}
          </Chips>
        </GridCol>
      </Grid>

      <Spacing spacing='xxsmall' />

      <Grid spacing='xxsmall'>
        {!!institutions.entity && (
          <GridCol width='auto'>
            <Link href={institutionsHref} passHref target='_blank'>
              <Param
                entity={institutions.entity}
                clarification={institutions.clarification}
                color='blue'
              />
            </Link>
          </GridCol>
        )}

        {!!score.entity && (
          <GridCol width='auto'>
            <Param entity={score.entity} clarification={score.clarification} />
          </GridCol>
        )}

        {!!budget.entity && (
          <GridCol width='auto'>
            <Param entity={budget.entity} clarification={budget.clarification} />
          </GridCol>
        )}
      </Grid>

      {!!shortDescription && (
        <>
          <Spacing spacing='xsmall' />

          <Text>{shortDescription}</Text>
        </>
      )}

      <Spacing spacing='small' />

      {examsSts.map(({ title, subjects }, index) => {
        if (!shownAllEge && index) return null

        return (
          <Fragment key={index}>
            <Grid spacing='usmall' alignItems='center'>
              <GridCol width='auto'>
                <Text fontWeight='bold' fontSize='small1' lineHeight='small1'>
                  {title}
                </Text>
              </GridCol>

              {subjects.map(({ id: examId, name: examName, slug }) => {
                const Icon = icons[slug]

                const isRedColor =
                  exams && !exams?.some((el) => Number(el.id) === Number(examId))

                return (
                  <GridCol width='auto' key={examId}>
                    <GridSC spacing='uxsmall' alignItems='center'>
                      {Icon && (
                        <Icon
                          color={isRedColor ? 'red' : 'black'}
                          width='20px'
                          height='20px'
                        />
                      )}

                      <Text
                        as='span'
                        fontSize='small1'
                        lineHeight='small1'
                        firstLetterUppercase
                        color={isRedColor ? 'red' : 'black'}
                      >
                        {examName}
                      </Text>
                    </GridSC>
                  </GridCol>
                )
              })}

              {!shownAllEge && !index && examsSts.length > 1 && (
                <GridCol width='auto'>
                  &nbsp;
                  <Button
                    view='link'
                    size='xxsmall'
                    color='black'
                    EndIcon={<SpecialitiesListIconMore />}
                    onClick={showAllEge}
                  >
                    Все варианты
                  </Button>
                </GridCol>
              )}
            </Grid>

            {shownAllEge && examsSts.length > 0 && examsSts.length - 1 !== index && (
              <Spacing spacing='xxsmall' />
            )}
          </Fragment>
        )
      })}

      {showSelect && (
        <>
          <Spacing spacing='medium' />

          {selectedItems?.some((selectId) => Number(selectId) === Number(id)) ? (
            <Button
              color='blue'
              view='outline'
              StartIcon={<CheckIcon />}
              width='156px'
              onClick={() => {
                if (offSelect && !isLoading) {
                  offSelect(Number(id))
                  setPanding(true)
                }
              }}
              progress={panding}
            >
              Выбрано
            </Button>
          ) : (
            <Button
              color='blue'
              width='156px'
              onClick={() => {
                if (onSelect && !isLoading) {
                  onSelect(Number(id))
                  setPanding(true)
                }
              }}
              progress={panding}
            >
              Выбрать
            </Button>
          )}
        </>
      )}
    </Block>
  )
}

export { SpecialitiesListItem }
export default memo(SpecialitiesListItem)
